import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, UncontrolledTooltip } from "reactstrap"
import { useHistory } from "react-router"
import { connect } from "react-redux"
import { openWelcome } from "store/actions"
import { isMobile, isMobileOnly } from "react-device-detect"

const vidi = {
  position: "relative",
  height: "100%",
  width: "100vw",
  overflow: "hidden scroll",
  display: "none",
}

const Dashboard = props => {
  const { welcome, onOpenWelcome } = props
  const [newImgSrc, setNewImgSrc] = useState("")
  const [fixState,setFixState] = useState(false)

  const videoSrc = isMobile
    ? "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/SEES%20-%20constellation%20of%20us%2FWalkthrough.mp4?alt=media&token=ce1164e2-7354-4098-8741-33f1e25226d3"
    : "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/SEES%20-%20constellation%20of%20us%2FWalkthrough.mp4?alt=media&token=ce1164e2-7354-4098-8741-33f1e25226d3"
  const imgSrc = isMobile
    ? "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/SEES%20-%20constellation%20of%20us%2FClick%20to%20Enter.jpg?alt=media&token=c4c95444-6f6b-427d-a107-fee74ff31b68"
    : "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/SEES%20-%20constellation%20of%20us%2FClick%20to%20Enter.jpg?alt=media&token=c4c95444-6f6b-427d-a107-fee74ff31b68"

  const history = useHistory()
  function tAdd() {
    const body = document.body
    body.classList.add("vertical-collpsed")
    body.classList.add("sidebar-enable")
  }

  useEffect(() => {
    const checkScreenSize = () => {
      if (window.innerWidth < 500) {
        window.location.reload();
        document.getElementById("skip1").style.display = "none"
        setNewImgSrc(
          "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/apple%20virtual%20platform%2FRotate%20Your%20Phone.gif?alt=media&token=797900cb-990e-466a-9182-c675914732ab"
        )
        setFixState(!fixState);

      }else{
        document.getElementById("skip1").style.display = "block"

          setNewImgSrc(
            "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/SEES%20-%20constellation%20of%20us%2FClick%20to%20Enter.jpg?alt=media&token=c4c95444-6f6b-427d-a107-fee74ff31b68"
          )
          setFixState(!fixState);
        }
      }

    checkScreenSize()
    window.addEventListener("resize", checkScreenSize)

    return () => {
      window.removeEventListener("resize", checkScreenSize)
    }
  }, [])

  const loader = document.querySelector(".loader")

  useEffect(() => {
    loader.classList.add("loader--hide")
  }, [])
  return (
    <React.Fragment>
      <div style={{ padding: 0 }} className="page-content">
        <MetaTags>
          <title>Constellation Of Us</title>
        </MetaTags>

        <Container style={{ padding: 0 }} fluid>
          <img
            onClick={() => history.push("/page/lobby")}
            id="img-1"
            alt=""
            src={fixState?newImgSrc:imgSrc}
            width="100%"
            loading="lazy"
          />

          {/* <img
            src={imgSrc} // Default fallback image
            srcSet={`
    https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/apple%20virtual%20platform%2FRotate%20Your%20Phone.gif?alt=media&token=797900cb-990e-466a-9182-c675914732ab 500w,
    ${imgSrc} 501w
  `}
            sizes="(max-width: 500px) 100vw, 50vw"
            style={{
              top: "0%",
              width: "100%",
              position: "absolute",
              height: "100%",
              left: "0%",
              objectFit: "cover",
            }}
            loading="eager" 
          /> */}

          <div>
            <UncontrolledTooltip target="skip1">Skip</UncontrolledTooltip>
            <div
              id="skip1"
              // onClick={() => { history.push("/page/lobby") }} //addedy
              onClick={() => {
                //change here for redirection after on click on skip
                history.push("/page/lobby")
              }}
              style={{
                cursor: "pointer",
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // transform: "skew(0deg, 0deg)",
                position: "absolute",
                // width: "fit-content",
                // background: "linear-gradient(to right, #0b90e3, #5c16d0)",
                // fontSize: "1.1rem",
                top: "10%",
                left: "75%",
                zIndex: "3",
                // padding: "0 1.5%",
                // borderRadius: "20px",
                // border: "2px solid white",
                // color: "white",
              }}
            >
              <div className="Btncontainer">
                <button type="submit" className="Btnbutton">
                  <div className="Btnstar"></div>
                  <div className="Btnstar s2"></div>
                  <div className="Btnstar s3"></div>
                  <span>Skip</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="40px"
                    viewBox="0 -960 960 960"
                    width="40px"
                    fill="#fff"
                    display="none"
                  >
                    <path d="M521.33-480.67 328-674l47.33-47.33L616-480.67 375.33-240 328-287.33l193.33-193.34Z" />
                  </svg>
                  <div className="Btnmoon"></div>
                </button>
              </div>
                
            </div>
          </div>
          <div>
            <UncontrolledTooltip target="click2enter">
              Click to Enter
            </UncontrolledTooltip>

            <div
              id="click2enter"
              // onClick={() => { history.push("/page/lobby") }} //addedy
              onClick={() => {
                // onOpenWelcome();
                document.getElementById("vid-1").style.display = "block"
                document.getElementById("img-1").style.display = "none"
                document.getElementById("vid-1").play()
              }}
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transform: "skew(0deg, 0deg)",
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0%",
                left: "0%",
              }}
            ></div>
          </div>

          <video
            preload="auto"
            id="vid-1"
            src={videoSrc}
            style={vidi}
            autostart="false"
            onLoadStart={() => {
              tAdd()
            }}
            onEnded={() => {
              history.push("/page/lobby")
            }}
          ></video>
        </Container>
      </div>
    </React.Fragment>
  )
}

// export default Dashboard

const mapStateToProps = ({ agenda }) => ({
  welcome: agenda.welcome,
})

const mapDispatchToProps = dispatch => ({
  onOpenWelcome: () => dispatch(openWelcome()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
